/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Integrations_Dialog_Actions_SubtitleInputs */



/**
* | output |
* | --- |
* | "Function calls the AI can invoke when this integration is enabled." |
*
* @param {Integrations_Dialog_Actions_SubtitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const integrations_dialog_actions_subtitle = /** @type {((inputs?: Integrations_Dialog_Actions_SubtitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Integrations_Dialog_Actions_SubtitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Funktionsaufrufe, die die KI nutzen kann, sobald diese Integration aktiviert ist.")
	return /** @type {LocalizedString} */ ("Function calls the AI can invoke when this integration is enabled.")
});